import React from 'react';
import { useTranslation } from 'react-i18next';

const Home: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <div>
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-mypa-green/90 to-mypa-blue/90 text-white py-20">
        <div className="container-custom">
          <div className="max-w-3xl">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              {t("home.hero.title")}
            </h1>
            <p className="text-xl mb-8">
              {t("home.hero.subtitle")}
            </p>
            <a href="/nos-offres" className="bg-white text-mypa-green hover:bg-mypa-light font-bold py-3 px-6 rounded-lg transition-colors">
              {t("home.hero.cta")}
            </a>
          </div>
        </div>
      </section>
      
      {/* Economic Models Section */}
      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-mypa-blue mb-4">
              {t("home.models.title")}
            </h2>
            <p className="text-xl max-w-3xl mx-auto">
              {t("home.models.subtitle")}
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-mypa-light p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-bold text-mypa-blue mb-3">
                {t("home.models.classic.title")}
              </h3>
              <p>
                {t("home.models.classic.description")}
              </p>
            </div>
            
            <div className="bg-mypa-light p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-bold text-mypa-blue mb-3">
                {t("home.models.performance.title")}
              </h3>
              <p>
                {t("home.models.performance.description")}
              </p>
            </div>
            
            <div className="bg-mypa-light p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-bold text-mypa-blue mb-3">
                {t("home.models.shared.title")}
              </h3>
              <p>
                {t("home.models.shared.description")}
              </p>
            </div>
            
            <div className="bg-mypa-light p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-bold text-mypa-blue mb-3">
                {t("home.models.knowledge.title")}
              </h3>
              <p>
                {t("home.models.knowledge.description")}
              </p>
            </div>
          </div>
        </div>
      </section>
      
      {/* Benefits Section */}
      <section className="section-padding bg-mypa-light">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-mypa-blue mb-4">
              {t("home.benefits.title")}
            </h2>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-bold text-mypa-green mb-3">
                {t("home.benefits.adapted.title")}
              </h3>
              <p>
                {t("home.benefits.adapted.description")}
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-bold text-mypa-green mb-3">
                {t("home.benefits.innovative.title")}
              </h3>
              <p>
                {t("home.benefits.innovative.description")}
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-bold text-mypa-green mb-3">
                {t("home.benefits.expertise.title")}
              </h3>
              <p>
                {t("home.benefits.expertise.description")}
              </p>
            </div>
          </div>
        </div>
      </section>
      
      {/* CTA Section */}
      <section className="section-padding bg-mypa-blue text-white">
        <div className="container-custom text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Prêt à réduire votre empreinte carbone ?
          </h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            Découvrez comment nos solutions peuvent vous aider à atteindre vos objectifs de décarbonation.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="/calculateur-carbone" className="btn-primary bg-mypa-green">
              Estimer mon empreinte
            </a>
            <a href="/contact" className="btn-outline border-white text-white hover:bg-white hover:text-mypa-blue">
              Nous contacter
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
